export type DatedWrite = {
	/** Absent on older writes; their day is the date of `createdAt`. */
	localDate?: string;
	createdAt: Date;
};

/*
 * The grid day a write applies to, YYYY-MM-DD.
 */
export const dayOf = (write: DatedWrite) =>
	write.localDate ?? write.createdAt.toISOString().slice(0, 10);

/*
 * The order the grid resolves writes in, the same as the talent review
 * service: latest day first, newest write first within a day. A later edit of
 * an earlier day therefore never beats a write of a later day.
 */
export const byGridOrder = (left: DatedWrite, right: DatedWrite): number => {
	const leftDay = dayOf(left);
	const rightDay = dayOf(right);

	if (leftDay !== rightDay) {
		return leftDay > rightDay ? -1 : 1;
	}

	return right.createdAt.getTime() - left.createdAt.getTime();
};

/*
 * Whether the grid shows `write` over `current`.
 */
export const supersedes = (write: DatedWrite, current: DatedWrite) =>
	byGridOrder(write, current) < 0;
